// extracted by mini-css-extract-plugin
export default {"type":"BackupRow-type-cEm0B TableRowCell-cell-giPrj","actions":"BackupRow-actions-jEOfc TableRowCell-cell-giPrj"};